import { Outlet, useOutletContext } from 'react-router-dom'

import { CostCentersList } from 'modules/cost_centers/components/CostCenterList'
import { CostCentersStructure } from 'modules/cost_centers/components/CostCentersStructure'
import { CostCenterConfigurations } from 'modules/cost_centers/lib/types'

const CostCentersListPage = () => {
  const {
    canManageCostCenters,
    hasNewStructureEnabled,
    hasFeatureCostCenterManagement,
    configurations,
  } = useOutletContext<{
    canManageCostCenters: boolean
    hasNewStructureEnabled: boolean
    hasFeatureCostCenterManagement: boolean
    configurations: CostCenterConfigurations
  }>()

  return (
    <>
      {hasNewStructureEnabled ? (
        <CostCentersStructure
          canManageCostCenters={canManageCostCenters}
          configurations={configurations}
        />
      ) : (
        <CostCentersList canManageCostCenters={canManageCostCenters} />
      )}
      <Outlet
        context={{
          canManageCostCenters,
          hasFeatureCostCenterManagement,
        }}
      />
    </>
  )
}

export default CostCentersListPage
